module.exports = __webpack_public_path__ + "media/images/athletes/2802-2b1241c7c2fe36b8c690e0c5d3620e0f.png";